'use client';

interface Props {
  value: number;    // 0–100
  color?: string;
  height?: number;
  animated?: boolean;
  showLabel?: boolean;
  label?: string;
}

export function ProgressBar({
  value,
  color = 'var(--color-primary)',
  height = 6,
  animated = true,
  showLabel = false,
  label,
}: Props) {
  const clamped = Math.min(Math.max(value, 0), 100);

  return (
    <div className="w-full">
      {(showLabel || label) && (
        <div className="flex justify-between items-center mb-1">
          {label && (
            <span className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
              {label}
            </span>
          )}
          {showLabel && (
            <span className="text-xs font-medium" style={{ color: 'var(--color-text-secondary)' }}>
              {clamped}%
            </span>
          )}
        </div>
      )}
      <div
        className="w-full rounded-full overflow-hidden"
        style={{
          height,
          background: 'rgba(255,255,255,0.08)',
        }}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full rounded-full"
          style={{
            width: `${clamped}%`,
            background: color,
            transition: animated ? 'width 0.6s ease' : 'none',
          }}
        />
      </div>
    </div>
  );
}
